import uuid from 'uuid/v4';
import {call} from 'redux-saga/effects';
import {get} from 'src/services/users/api';
import {fields} from 'src/types';
import {NA} from 'src/utils/pipeline/match';
import cache from './cache';

export default (flows) => {
  flows.getFlow('get').setActions({
    onFetch: function* () {
      cache.data = [];
      cache.index = {};

      yield flows.getFlow('get').setData({ hash: uuid(), length: 0 });

      const { data } = yield call(() => get());

      const fieldsIndex = {
        [fields.STATUS.name]: [NA, 'Online', 'Offline'],
      };

      const fieldsValuesSet = {
        // include all boolean fields,
        /*
        ...(
          Object.keys(fields)
            .filter(key => fields[key].isBoolean)
            .reduce((prev, key) => ({ ...prev, [fields[key].name]: {} }), {})
        ),
        */

        [fields.TYPE.name]: {},
        [fields.STATE.name]: {},
        [fields.COUNTRY_CODE.name]: {},
        [fields.IS_GAIA.name]: {},
        [fields.SERVICE_GROUP.name]: {},
      };

      const prepareValues = (row) => {
        Object.keys(row).forEach(key => {
          if (typeof row[key] === 'string') {
            row[key] = row[key].trim();
          }
        });
      };

      const collectUniqueValues = (row) => {
        Object.keys(fieldsValuesSet).forEach(field => {
          const value = row[field] || row[field] === false ? row[field] : NA;
          fieldsValuesSet[field][value] = true;
        });
      };

      const payload = data.reduce((prev, curr) => {
        const {
          id: user_id,
          last_updated_at: user_last_updated_at,
          is_gaia,
          structures,
          ...user
        } = curr;

        const flatUser = {
          uuid: user_id,
          user_id,
          user_last_updated_at,
          ...user,
        };

        if (structures && structures.length > 0) {
          for (let i = 0; i < structures.length; i++) {
            const {
              id: structure_id,
              devices,
              ...structure
            } = structures[i];

            const flatStructure = {
              ...flatUser,
              uuid: `${user_id}/${structure_id}`,
              structure_id,
              ...structure,
            };

            if (devices && devices.length > 0) {
              for (let j = 0; j < devices.length; j++) {
                const {
                  id: device_id,
                  last_updated_at: device_last_updated_at,
                  is_online,
                  resource_id,
                  ...device
                } = devices[j];

                const modGAIA = resource_id ? is_gaia : null;

                const row = {
                  ...flatStructure,
                  uuid: `${user_id}/${structure_id}/${device_id}`,
                  device_id,
                  device_last_updated_at,
                  resource_id,
                  [fields.STATUS.name]: is_online
                    ? fieldsIndex[fields.STATUS.name][1]
                    : (
                      is_online === false
                        ? fieldsIndex[fields.STATUS.name][2]
                        : fieldsIndex[fields.STATUS.name][0]
                    ),
                  [fields.IS_GAIA.name]: modGAIA
                    ? 'Merged'
                    : (modGAIA === false ? 'Nest' : 'GAIA'),
                  ...device,
                };

                prepareValues(row);
                collectUniqueValues(row);
                prev.push(row);
              }
            } else {
              prepareValues(flatStructure);
              collectUniqueValues(flatStructure);

              // Don't show empty structures (without devices)
              //  prev.push(flatStructure);
            }
          }
        } else {
          prepareValues(flatUser);
          collectUniqueValues(flatUser);

          // Don't show users without structures
          //  prev.push(flatUser);
        }

        return prev;
      }, []);

      // push fields unique values to the INDEX array
      Object.keys(fieldsValuesSet).forEach(field => {
        const first = fieldsValuesSet[field][NA] ? [NA] : [];

        delete fieldsValuesSet[field][NA];

        fieldsIndex[field] = [...first, ...Object.keys(fieldsValuesSet[field]).sort()];
      });

      cache.data = payload;
      cache.index = fieldsIndex;

      return { hash: uuid(), count: Object.keys(payload).length, };
    },
  });

  return flows.getSagas();
};
